<template>
  <v-container fluid class="pessoas-geral-page pa-4 pa-md-6">
    <!-- Filtros -->
    <v-card outlined class="filter-card mb-6">
      <v-card-text class="pb-2">
        <div class="d-flex align-center mb-3">
          <v-icon color="grey" class="mr-2">mdi-filter-variant</v-icon>
          <span class="subtitle-1 font-weight-medium grey--text text--darken-2">Filtros</span>
        </div>
        <v-row align="center">
          <v-col cols="12" sm="5">
            <v-select
              v-model="select_equipe"
              :items="selects.candidatos.items"
              :disabled="selects.candidatos.ativado"
              @change="getMetas(select_equipe)"
              outlined
              dense
              label="Equipe"
              item-value="idcandidato"
              item-text="nome_completo"
              prepend-inner-icon="mdi-account-group"
              hide-details="auto"
              class="styled-select"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="5">
            <v-select
              v-model="select_meta"
              :items="selects.metas.items"
              outlined
              dense
              label="Tipo de Meta"
              item-value="idmeta"
              item-text="descricao"
              prepend-inner-icon="mdi-target"
              hide-details="auto"
              class="styled-select"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="2" class="d-flex justify-center">
            <v-btn
              color="primary"
              dark
              depressed
              class="btn-buscar"
              @click="buscar()"
            >
              <v-icon left>mdi-magnify</v-icon>
              Buscar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Tabela -->
    <v-card outlined class="table-card">
      <v-data-table
        :headers="headers"
        :items="desserts"
        height="65vh"
        :options.sync="options"
        :server-items-length="totalRegistros"
        :footer-props="{
          itemsPerPageOptions: [500, 1000, 2000, 3000, 4000],
          'items-per-page-text': 'Itens por página',
        }"
        :fixed-header="true"
        class="modern-table"
      >
        <template v-slot:top>
          <div class="table-header pa-4">
            <v-row align="center">
              <v-col cols="12" sm="4">
                <div class="d-flex align-center">
                  <v-icon color="grey" size="28" class="mr-3">mdi-account-multiple</v-icon>
                  <div>
                    <div class="title font-weight-bold" style="color: #757575">Cadastro Geral</div>
                    <div class="caption grey--text" v-if="totalRegistros > 0">
                      {{ totalRegistros }} registros
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  :value="search"
                  append-icon="mdi-magnify"
                  label="Pesquisar"
                  single-line
                  hide-details
                  outlined
                  dense
                  class="styled-select"
                  @input="onSearch"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" class="d-flex justify-end align-center">
                <v-tooltip bottom v-if="metas.total_cad > 0">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      class="mr-2 action-icon-btn"
                      v-on="on"
                      @click="getReportAssessor"
                    >
                      <v-icon>mdi-printer</v-icon>
                    </v-btn>
                  </template>
                  <span>Imprimir Lista de Cadastro</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </div>
          <v-divider></v-divider>
        </template>

        <!-- Coluna Observações (truncada + tooltip) -->
        <template v-slot:item.observacoes="{ item }">
          <v-tooltip bottom :disabled="!item.observacoes">
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ truncar(item.observacoes, 60) }}</span>
            </template>
            <span>{{ item.observacoes }}</span>
          </v-tooltip>
        </template>

        <!-- Coluna Meta com chip -->
        <template v-slot:item.meta_descricao="{ item }">
          <v-chip
            v-if="item.meta_descricao"
            small
            color="#e0f2f1"
            text-color="#216b80"
            class="font-weight-medium"
          >
            {{ item.meta_descricao }}
          </v-chip>
          <span v-else class="grey--text text--lighten-1">—</span>
        </template>

        <!-- Coluna Ações -->
        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon small class="action-icon-btn" v-on="on" @click="editItem(item)">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>
        </template>

        <!-- Estado vazio -->
        <template v-slot:no-data>
          <div v-if="buscaAplicada" class="text-center pa-10">
            <v-icon size="64" color="grey lighten-2" class="mb-4">mdi-magnify-close</v-icon>
            <div class="subtitle-1 grey--text">Nenhum resultado para "{{ buscaAplicada }}"</div>
          </div>
          <div v-else class="text-center pa-10">
            <v-icon size="64" color="grey lighten-2" class="mb-4">mdi-account-search</v-icon>
            <div class="subtitle-1 grey--text">Nenhum registro encontrado</div>
            <div class="caption grey--text text--lighten-1">
              Selecione os filtros acima e clique em Buscar
            </div>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- Dialog Criar/Editar -->
    <v-dialog
      persistent
      v-model="dialog"
      max-width="600px"
      content-class="dialog-modern"
    >
      <v-card class="dialog-card">
        <div class="dialog-header pa-5">
          <div class="d-flex align-center">
            <v-icon color="grey" class="mr-3">{{ editedIndex === -1 ? 'mdi-account-plus' : 'mdi-account-edit' }}</v-icon>
            <span class="title font-weight-bold" style="color: #757575">{{ formTitle }}</span>
          </div>
        </div>
        <v-card-text class="pt-6 px-6">
          <v-row>
            <v-col
              cols="12"
              v-if="editedIndex !== -1 && equipesPessoa.length"
            >
              <div class="text-caption text--secondary mb-1">
                Equipes vinculadas
              </div>
              <v-chip
                v-for="(nome, i) in equipesPessoa"
                :key="i"
                x-small
                class="ma-1"
                color="grey lighten-2"
              >
                {{ nome }}
              </v-chip>
            </v-col>

            <v-col cols="12">
              <v-text-field
                outlined
                dense
                v-model="editedItem.nome_completo"
                counter
                label="Nome Completo *"
                prepend-inner-icon="mdi-account"
                :error-messages="nameErrors"
                @input="$v.editedItem.nome_completo.$touch()"
                @blur="$v.editedItem.nome_completo.$touch()"
                class="styled-input"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field
                outlined
                dense
                v-model="editedItem.titulo_eleitoral"
                label="Código principal *"
                prepend-inner-icon="mdi-ballot-outline"
                v-mask="'#### #### ####'"
                :error-messages="tituloEleitoralErrors"
                @input="$v.editedItem.titulo_eleitoral.$touch()"
                @blur="$v.editedItem.titulo_eleitoral.$touch()"
                class="styled-input"
              ></v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                outlined
                dense
                v-model="editedItem.cpf"
                label="CPF"
                prepend-inner-icon="mdi-card-account-details"
                v-mask="'###.###.###-##'"
                :error-messages="cpfErrors"
                @input="$v.editedItem.cpf.$touch()"
                @blur="$v.editedItem.cpf.$touch()"
                class="styled-input"
              ></v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                outlined
                dense
                v-model="editedItem.telefone"
                label="Telefone *"
                prepend-inner-icon="mdi-phone"
                :error-messages="telefoneErrors"
                v-mask="'(##) #####-####'"
                @input="$v.editedItem.telefone.$touch()"
                @blur="$v.editedItem.telefone.$touch()"
                class="styled-input"
              ></v-text-field>
            </v-col>

            <v-col cols="6">
              <v-select
                v-model="editedItem.zona"
                :items="selects.zonas.items"
                item-value="zona"
                item-text="zona"
                chips
                small-chips
                label="Zona *"
                outlined
                dense
                prepend-inner-icon="mdi-map-marker"
                :error-messages="zonaErrors"
                @input="$v.editedItem.zona.$touch()"
                @blur="$v.editedItem.zona.$touch()"
                class="styled-input"
              ></v-select>
            </v-col>

            <v-col cols="6">
              <v-text-field
                outlined
                dense
                v-model="editedItem.secao"
                label="Seção *"
                prepend-inner-icon="mdi-map"
                :error-messages="secaoErrors"
                v-mask="'####'"
                @input="$v.editedItem.secao.$touch()"
                @blur="$v.editedItem.secao.$touch()"
                class="styled-input"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field
                outlined
                dense
                v-model="editedItem.email"
                label="Email"
                prepend-inner-icon="mdi-email"
                :error-messages="emailErrors"
                @input="$v.editedItem.email.$touch()"
                @blur="$v.editedItem.email.$touch()"
                class="styled-input"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-textarea
                outlined
                dense
                auto-grow
                rows="3"
                v-model="editedItem.observacoes"
                prepend-inner-icon="mdi-note-text-outline"
                label="Observações"
                class="styled-input"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn outlined color="grey darken-1" class="btn-action mr-3" @click="close">
            <v-icon left small>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-btn depressed dark color="primary" class="btn-action" @click="save">
            <v-icon left small>mdi-check</v-icon>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { required, email, minLength } from "vuelidate/lib/validators";
import { helpers } from "vuelidate/lib/validators";
import AclAPI from "./../../api/acl";
import { validarCPF, validarTituloEleitoral } from "./../../helpers";

export default {
  props: ["atualizarUsu"],
  name: "Acl",
  data: () => ({
    dialog: false,
    search: "",
    // Paginacao, ordenacao e busca no servidor (a base nao cabe inteira no navegador).
    buscaAplicada: "",
    buscaTimer: null,
    buscou: false,
    ultimaChave: null,
    totalRegistros: 0,
    options: {
      page: 1,
      itemsPerPage: 1000,
      sortBy: [],
      sortDesc: [],
    },
    // Equipes vinculadas a pessoa em edicao (somente leitura nesta tela).
    equipesPessoa: [],
    headers: [
      {
        text: "ID",
        value: "idpessoa",
      },
      {
        text: "Nome Completo",
        align: "left",
        value: "nome_completo",
      },

      { text: "Telefone", value: "telefone" },
      { text: "Email", value: "email" },
      { text: "Assessor", value: "assessor" },
      { text: "Observações", value: "observacoes", sortable: false },
      { text: "Meta", value: "meta_descricao" },
      { text: "Ações", value: "action", sortable: false },
    ],
    desserts: [],
    editedIndex: -1,
    select_equipe: 0,
    select_meta: 0,

    selects: {
      perfil: {
        items: [],
      },

      candidatos: {
        ativado: false,
        value: 0,
        items: [],
      },
      metas: {
        value: 0,
        items: [],
      },
      zonas: {
        value: 0,
        items: [],
      },
    },
    editedItem: {
      id: "",
      nome_completo: "",
      cpf: "",
      titulo_eleitoral: "",
      email: "",
      telefone: "",
      zona: "",
      secao: "",
      facebook: "",
      instagram: "",
      observacoes: "",
    },
    defaultItem: {
      id: "",
      nome_completo: "",
      cpf: "",
      titulo_eleitoral: "",
      email: "",
      telefone: "",
      zona: "",
      secao: "",
      facebook: "",
      instagram: "",
      observacoes: "",
    },
    metas: {
      total: "",
      total_cad: "",
      show: true,
    },
  }),

  validations: {
    editedItem: {
      nome_completo: {
        required,
        minLength: minLength(6),
      },
      cpf: {
        cpfValido: (v) => !v || validarCPF(v),
      },
      titulo_eleitoral: {
        required,
        tituloValido: (v) => validarTituloEleitoral(v),
      },
      email: {
        email,
      },
      telefone: {
        required,
        isPhoneNumber: helpers.regex(
          "telefone",
          /^\(([0-9]{2})\) 9([0-9])(?!\2{3}-(\2{4}))([0-9]{3})-([0-9]{4})$/
        ),
      },

      zona: {
        required,
      },
      secao: {
        required,
      },
    },
  },

  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.editedItem.nome_completo.$dirty) return errors;
      !this.$v.editedItem.nome_completo.required &&
        errors.push("Campo Obrigatório.");
      !this.$v.editedItem.nome_completo.minLength &&
        errors.push("A Nome Completo  dever ser maior que 6 caracteres");
      return errors;
    },
    cpfErrors() {
      const errors = [];
      if (!this.$v.editedItem.cpf.$dirty) return errors;
      !this.$v.editedItem.cpf.cpfValido && errors.push("CPF inválido.");
      return errors;
    },
    tituloEleitoralErrors() {
      const errors = [];
      if (!this.$v.editedItem.titulo_eleitoral.$dirty) return errors;
      !this.$v.editedItem.titulo_eleitoral.required &&
        errors.push("Código principal é obrigatório.");
      !this.$v.editedItem.titulo_eleitoral.tituloValido &&
        errors.push("Código principal inválido.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.editedItem.email.$dirty) return errors;
      !this.$v.editedItem.email.email && errors.push("Email incorreto.");
      return errors;
    },
    telefoneErrors() {
      const errors = [];
      if (!this.$v.editedItem.telefone.$dirty) return errors;
      !this.$v.editedItem.telefone.required &&
        errors.push("Campo Obrigatório.");
      !this.$v.editedItem.telefone.isPhoneNumber &&
        errors.push("Número de Telefone fora do Padrão");
      return errors;
    },
    zonaErrors() {
      const errors = [];
      if (!this.$v.editedItem.zona.$dirty) return errors;
      !this.$v.editedItem.zona.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    secaoErrors() {
      const errors = [];
      if (!this.$v.editedItem.secao.$dirty) return errors;
      !this.$v.editedItem.secao.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Nova Pessoa" : "Editar Pessoa";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },

    atualizarUsu() {
      if (this.buscou) this.initialize(true);
    },

    options: {
      handler() {
        if (this.buscou) this.initialize();
      },
      deep: true,
    },
  },

  beforeDestroy() {
    clearTimeout(this.buscaTimer);
  },

  created() {
    this.buscaCandidatos();
    this.buscaZonas();
    //this.initialize();
  },

  methods: {
    // Trunca um texto para exibicao na coluna, mantendo o valor completo no tooltip.
    truncar(texto, n) {
      if (!texto) return "";
      return texto.length > n ? texto.slice(0, n) + "…" : texto;
    },

    buscar() {
      this.buscou = true;
      if (this.options.page !== 1) {
        this.options = { ...this.options, page: 1 };
      }
      this.initialize(true);
    },

    // Busca no servidor (colunas da tabela + CPF/titulo so pelos digitos), com debounce.
    onSearch(valor) {
      this.search = valor || "";
      clearTimeout(this.buscaTimer);
      this.buscaTimer = setTimeout(() => {
        this.buscaAplicada = this.search.trim();
        if (!this.buscou) return;
        if (this.options.page !== 1) {
          this.options = { ...this.options, page: 1 };
        } else {
          this.initialize();
        }
      }, 500);
    },

    // forcar: refaz a consulta mesmo com os mesmos parametros (Buscar, apos salvar/excluir).
    initialize(forcar = false) {
      const params = {
        equipe: this.select_equipe,
        meta: this.select_meta,
        page: this.options.page,
        per_page: this.options.itemsPerPage > 0 ? this.options.itemsPerPage : 4000,
        search: this.buscaAplicada || undefined,
      };
      if (this.options.sortBy && this.options.sortBy.length) {
        params.sort_by = this.options.sortBy[0];
        params.sort_desc = this.options.sortDesc && this.options.sortDesc[0] ? 1 : 0;
      }

      // O options.sync da tabela dispara o watcher com os mesmos valores.
      const chave = JSON.stringify(params);
      if (!forcar && chave === this.ultimaChave) return;
      this.ultimaChave = chave;

      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch(
        "loading/addRequisicao",
        AclAPI.getPessoasGeral(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            if (response.status == 200) {
              this.desserts = response.data.pessoas;
              this.totalRegistros = Number(response.data.total) || 0;
              this.metas.total = response.data.metas ? parseFloat(response.data.metas.meta) : 0;
              // Sem busca: total do filtro (habilita a impressao da lista).
              if (!params.search) {
                this.metas.total_cad = parseFloat(response.data.total_cadastros);
              }

              if (
                this.metas.total_cad < this.metas.total ||
                (response.data.metas && response.data.metas.permite_exceder_meta == 1)
              ) {
                this.metas.show = true;
              } else {
                this.metas.show = false;
              }
            }
          })
          .catch((error) => {
            // Só sessão inválida derruba o usuário; erro de servidor fica na tela.
            if (error.response && error.response.status === 401) {
              this.Helpers.logout();
              return;
            }
            this.Helpers.exibirMensagem("Erro ao carregar o cadastro. Tente novamente.", "error", 6000);
          })
      );
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.equipesPessoa = (item.equipes_nomes || "")
        .split("||")
        .filter(Boolean);
      this.setZona(item.zona);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedItem = Object.assign({}, item);

      if (confirm("Deseja remover pessoa?")) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = this.editedItem;

        this.$store.dispatch(
          "loading/addRequisicao",
          AclAPI.delPessoa(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.editedItem = {};
                this.initialize(true);
              }
            })
            .catch(() => {
              alert("Falha na operação!!!");
            })
        );
      } else {
        this.editedItem = {};
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.equipesPessoa = [];
        this.editedIndex = -1;
      }, 300);
    },

    getReportAssessor() {
      const id_assessor = localStorage.getItem("id");
      const equipeParam =
        this.select_equipe && this.select_equipe !== "null"
          ? this.select_equipe
          : 0;

      let url =
        "relatorio_assessores?id=" +
        id_assessor +
        "&id_cd=" +
        id_assessor +
        "&equipe=" +
        equipeParam;
      window.open(process.env.VUE_APP_URL_BASE + "/api/" + url, "_blank");
    },

    save() {
      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();

        const id_assessor = localStorage.getItem("id");

        this.editedItem.id_assessor = id_assessor;

        // A tela administrativa nao gerencia vinculos de equipe: nunca envia
        // candidatos (o backend preserva pessoa_candidato quando a chave esta ausente).
        const params = Object.assign({}, this.editedItem);
        delete params.candidatos;
        delete params.equipes_nomes;

        this.$store.dispatch(
          "loading/addRequisicao",
          AclAPI.addPessoa(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.initialize(true);
                this.close();
              }
            })
            .catch((error) => {
              const err = error.response && error.response.data && error.response.data.error;
              if (error.response && error.response.status === 422 && err === "cpf_duplicado") {
                this.Helpers.exibirMensagem(
                  `CPF já cadastrado para ${error.response.data.nome}`,
                  "error",
                  6000
                );
              } else if (error.response && error.response.status === 422 && err === "titulo_duplicado") {
                const eq = error.response.data.equipe;
                this.Helpers.exibirMensagem(
                  `Código principal já cadastrado para ${error.response.data.nome}` +
                    (eq ? ` na equipe ${eq}` : ""),
                  "error",
                  6000
                );
              } else if (error.response && error.response.status === 422 && err === "titulo_invalido") {
                this.Helpers.exibirMensagem("Código principal inválido", "error", 6000);
              } else if (error.response && error.response.status === 422 && err === "telefone_limite") {
                const nomes = (error.response.data.pessoas || []).join(" e ");
                this.Helpers.exibirMensagem(
                  `Este telefone já está cadastrado para 2 pessoas${nomes ? " (" + nomes + ")" : ""}. Não é permitido um terceiro cadastro com o mesmo telefone.`,
                  "error",
                  7000
                );
              } else {
                alert("Falha na operação!!!");
              }
            })
        );
      }
    },
    buscaZonas() {
      const headers = this.Helpers.iniciarRequisicao();
      AclAPI.getZonas(headers)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          this.selects.zonas.items = [];

          if (response.status == 200) {
            this.selects.zonas.items = response.data.zonas;
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },
    buscaCandidatos() {
      const headers = this.Helpers.iniciarRequisicao();
      AclAPI.getCandidatos(headers)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          this.selects.candidatos.items = [];

          if (response.status == 200) {
            this.selects.candidatos.items = response.data.candidatos;

            let objCandidato = {
              idcandidato: "null",
              nome_completo: "TODOS",
              chapa: 0,
            };

            this.selects.candidatos.items.push(objCandidato);
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },
    getMetas(equipe) {
      const headers = this.Helpers.iniciarRequisicao();
      const params = {
        equipe: equipe,
        somente_cadastros: true,
      };

      AclAPI.getMetas(headers, params)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          this.selects.metas.items = [];

          if (response.status == 200) {
            this.selects.metas.items = response.data.metas;

            let objMetas = {
              idmeta: "null",
              descricao: "TODAS",
            };

            this.selects.metas.items.push(objMetas);
            this.select_meta = "null";
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },

    setZona(zona) {
      if (zona != "null") {
        this.editedItem.zona = parseInt(zona);
        this.selects.zonas.ativado = true;
      }
    },
  },
};
</script>
<style scoped>
.pessoas-geral-page {
  animation: fadeInUp 0.4s ease-out;
}

/* --- Cards --- */
.filter-card,
.table-card {
  border-radius: 16px !important;
  border-color: rgba(0, 0, 0, 0.08) !important;
  overflow: hidden;
}

.filter-card {
  background: #fafbfc !important;
}

/* --- Selects e Inputs estilizados --- */
.styled-select >>> .v-input__slot,
.styled-input >>> .v-input__slot {
  border-radius: 12px !important;
  min-height: 40px !important;
}

.styled-select >>> fieldset,
.styled-input >>> fieldset {
  border-color: rgba(0, 0, 0, 0.12);
  transition: border-color 0.2s ease;
}

.styled-select >>> .v-input--is-focused fieldset,
.styled-input >>> .v-input--is-focused fieldset {
  border-color: #216b80 !important;
  border-width: 2px;
}

/* --- Botões --- */
.btn-buscar {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600;
  letter-spacing: 0.3px;
  height: 40px !important;
  min-width: 120px !important;
  transition: all 0.2s ease;
}

.btn-buscar:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(33, 107, 128, 0.3) !important;
}

.btn-novo {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600;
  letter-spacing: 0.3px;
  transition: all 0.2s ease;
}

.btn-novo:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(33, 107, 128, 0.3) !important;
}

.btn-action {
  border-radius: 10px !important;
  text-transform: none !important;
  font-weight: 600;
  letter-spacing: 0.3px;
  min-width: 120px !important;
}

.action-icon-btn {
  transition: all 0.2s ease;
}

.action-icon-btn:hover {
  background: rgba(33, 107, 128, 0.08) !important;
  transform: scale(1.1);
}

/* --- Tabela --- */
.table-header {
  background: #fafbfc;
}

.modern-table >>> .v-data-table-header th {
  background: #f5f7fa !important;
  color: #5a6a7e !important;
  font-weight: 600 !important;
  font-size: 0.75rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
  border-bottom: 2px solid rgba(0, 0, 0, 0.08) !important;
}

.modern-table >>> .v-data-table-header th .v-icon {
  color: #5a6a7e !important;
}

.modern-table >>> tbody tr {
  transition: background-color 0.15s ease;
}

.modern-table >>> tbody tr:hover {
  background-color: rgba(33, 107, 128, 0.04) !important;
}

.modern-table >>> tbody td {
  font-size: 0.85rem !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06) !important;
}

.modern-table >>> .v-data-footer {
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

/* --- Dialog --- */
.dialog-card {
  border-radius: 20px !important;
  overflow: hidden;
}

.dialog-header {
  background: #ffffff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

/* --- Animação --- */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* --- Responsivo --- */
@media (max-width: 600px) {
  .pessoas-geral-page {
    padding: 8px !important;
  }

  .filter-card,
  .table-card {
    border-radius: 12px !important;
  }

  .btn-buscar {
    width: 100%;
  }
}
</style>
